var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceSettingsShockLight = function SvgDeviceSettingsShockLight(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 36,
    height: 36,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1016.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2996",
    fill: "currentColor",
    d: "m1.927 1041 7.455-5.312s.584-1.007.893-1.206 1.473-.268 1.473-.268l1.027-.536s.925-1.316 1.538-1.589 3.373-.107 3.373-.107 3.016-1.842 3.303-1.964c.288-.122 1.522-.172 3.527-.714s8.57-3.056 8.57-3.056.246-.016-.222 1.404-3.07 6.456-3.482 6.696-4.028-1.147-5.09.179c0 0 1.935 3.316 1.666 3.539s-3.763-1.396-3.763-1.396l-1.027-.179s1.067 1.996.74 2.168c-.329.171-1.988-1.05-1.988-1.05s-.346-.295-.13.484c.218.78 1.353 2.564 1.11 2.862s-2.277-.428-2.277-.428.07 1.209-.437 1.366-1.206-.107-1.206-.107l-2.946-2.822-.84.08 2.286 3.268s-4.563.263-4.946.045c-.383-.217-2.915-3.302-2.915-3.302l-5.655 2.269z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceSettingsShockLight);
export default ForwardRef;